/**
 * FAQ Category Listing — accordion toggle.
 *
 * One category open at a time per list. Hash-based auto-open on page load
 * using id="faq-cat-[term-slug]" on each list item.
 */

document.addEventListener('DOMContentLoaded', function () {

  function openItem(item) {
    item.classList.add('faq-category-listing__item--open');
    var trigger = item.querySelector('[data-faq-cat-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeItem(item) {
    item.classList.remove('faq-category-listing__item--open');
    var trigger = item.querySelector('[data-faq-cat-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  // -------------------------------------------------------------------------
  // Click handler — event delegation per list.
  // -------------------------------------------------------------------------

  document.querySelectorAll('[data-faq-cat-list]').forEach(function (list) {
    list.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-faq-cat-trigger]');
      if (!trigger) return;

      var item   = trigger.closest('[data-faq-cat-item]');
      var isOpen = item.classList.contains('faq-category-listing__item--open');

      list.querySelectorAll('.faq-category-listing__item--open').forEach(function (open) {
        closeItem(open);
      });

      if (!isOpen) openItem(item);
    });
  });

  // -------------------------------------------------------------------------
  // Hash-based auto-open on page load.
  // Matches id="faq-cat-[term-slug]" e.g. #faq-cat-bail-applications
  // Uses GSAP ScrollSmoother when available; falls back to scrollIntoView.
  // -------------------------------------------------------------------------

  var hash = window.location.hash;
  if (!hash) return;

  var target = document.querySelector('[data-faq-cat-item]' + hash);
  if (!target) return;

  openItem(target);

  setTimeout(function () {
    if (window.scrollSmoother) {
      if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
      window.scrollSmoother.scrollTo(target, true, 'top 80px');
    } else {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, 600);

});
